import React from 'react';

import styles from './styles';
import { Box } from '@material-ui/core';

import { CaptionDefault, HintPopup, Switch } from '@cobliteam/base-components';

const NoAccessHover = () => {
  return (
    <HintPopup
      title="Você não tem permissão para ver
      locais. Peça acesso ao administrador."
      arrow
      placement="bottom"
    >
      <Box className={styles.box}>
        <Switch size="medium" disabled />
        <CaptionDefault className={styles.text}>
          Locais de interesse
        </CaptionDefault>
      </Box>
    </HintPopup>
  );
};

export default NoAccessHover;
